// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1frXa","delete":"styles_delete__272WA","update":"styles_update__1HsV7","add":"styles_add__2fk0u"};